import { commonRequest } from '@/utils/request'

const actions = {
  save: ({ commit }, data) => commonRequest({ data, url: '/fair/save' }),
  list: ({ commit }, data) => commonRequest({ data, url: '/fair/list' }),
  remove: ({ commit }, data) => commonRequest({ data, url: '/fair/remove' }),
  photo: ({ commit }, data) => commonRequest({ data, url: '/fair/photo' }),
}

export default {
  namespaced: true,
  actions,
}
